import Version from './version';

export default (ua) => {
  let windvane = '0.0.0';
  let aliapp = false;
  let name = 'unkown';
  let version = '0.0.0';

  let matched = ua.match(/WindVane[/\s]([\d._]+)/);

  if (matched) {
    [, windvane] = matched;
  }

  /* istanbul ignore else */
  matched = ua.match(/AliApp\(([A-Z-\d]+)\/([\d.]+)\)/i);
  if (matched) {
    aliapp = {};
    [, name, version] = matched;
  } else if (ua.indexOf('TBIOS') > 0) { // 兼容手淘的一个bug，在webview初始化异常时，在ua中只包含TBIOS字样，也认为是手淘webview。
    name = 'TB';
  }

  if (aliapp) {
    aliapp.name = name;
    aliapp.windvane = new Version(windvane || '0.0.0');
    aliapp.version = new Version(version);

    Object.defineProperties(aliapp, { // Breaking change
      appname: {
        get() {
          throw new Error('Deprecated! Use env.aliapp.name instead');
        },
        enumerable: false,
      },
      platform: {
        get() {
          throw new Error('Deprecated! Use env.os.name instead');
        },
        enumerable: false,
      },
      poplayer: {
        get() {
          throw new Error('Deprecated! Use WindVane API: WVPopLayer.getPopLayerVersion');
        },
        enumerable: false,
      },
      poplayerVersion: {
        get() {
          throw new Error('Deprecated! Use WindVane API: WVPopLayer.getPopLayerVersion');
        },
        enumerable: false,
      },
    });
  }

  return aliapp;
};
